import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

// Quality Assurance Contacts

const setQualityAssuranceContact = (state, { qualityAssuranceContactData }) => {
  return state.merge({ qualityAssuranceContactData });
};

const setQualityAssuranceContactCheckEmail = (state, { qualityAssuranceContactCheckEmailData }) => {
  return state.merge({ qualityAssuranceContactCheckEmailData });
};

const setQualityAssuranceContactAll = (state, { qualityAssuranceContactAllData }) => {
  return state.merge({ qualityAssuranceContactAllData });
};

const setQualityAssuranceContactLoader = (state, { qualityAssuranceContactLoader }) => {
  return state.merge({ qualityAssuranceContactLoader });
};

// Quality Assurance Complaint Source
const setQualityAssuranceCS = (state, { qualityAssuranceCSData }) => {
  return state.merge({ qualityAssuranceCSData });
};

const setQualityAssuranceCSLoader = (state, { qualityAssuranceCSLoader }) => {
  return state.merge({ qualityAssuranceCSLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_CONTACT,
    actionFunction: setQualityAssuranceContact,
  },
  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_CONTACT_CHECK_EMAIL,
    actionFunction: setQualityAssuranceContactCheckEmail,
  },
  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_CONTACT_ALL,
    actionFunction: setQualityAssuranceContactAll,
  },
  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_CONTACT_LOADER_STATUS,
    actionFunction: setQualityAssuranceContactLoader,
  },
  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_C_S,
    actionFunction: setQualityAssuranceCS,
  },
  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_C_S_LOADER_STATUS,
    actionFunction: setQualityAssuranceCSLoader,
  },
];
